import { render, staticRenderFns } from "./Decoration13.vue?vue&type=template&id=2333286e&scoped=true"
import script from "./Decoration13.vue?vue&type=script&lang=js"
export * from "./Decoration13.vue?vue&type=script&lang=js"
import style0 from "./Decoration13.vue?vue&type=style&index=0&id=2333286e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333286e",
  null
  
)

export default component.exports